import { useState } from "react";
import { toast } from "react-toastify";
import { Field, NumberInput, Toggle, SmallButton } from "./formControls";

export const OffersTab = ({ form, updateField }) => {
  const [showForm, setShowForm] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const [offerPrice, setOfferPrice] = useState(0);
  const [offerType, setOfferType] = useState("dollar");

  const offers = form?.offers || [];

  const handleAdd = () => {
    if (parseInt(quantity) === 0 || parseFloat(offerPrice) === 0) {
      toast.error("Quantity and offer price cannot be 0");
      return;
    }
    const newOffer = {
      quantity: parseInt(quantity),
      offerPrice: parseFloat(offerPrice),
      offerType,
      isActive: offers.length === 0,
    };
    updateField("offers", [...offers, newOffer]);
    setQuantity(0);
    setOfferPrice(0);
    setShowForm(false);
  };

  const handleDelete = (index) => {
    updateField("offers", offers.filter((_, i) => i !== index));
  };

  const handleSetActive = (index) => {
    updateField("offers", offers.map((o, i) => ({ ...o, isActive: i === index })));
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between border-b border-gray-200 pb-3">
        <h4 className="text-sm font-semibold text-gray-800">Offers</h4>
        <div className="flex items-center gap-3">
          <span className="text-xs text-gray-500">Offer Applied</span>
          <Toggle
            id="offerApplied"
            checked={!!form?.isOfferApplied}
            onChange={(e) => updateField("isOfferApplied", e.target.checked)}
          />
        </div>
      </div>

      {!showForm && (
        <button type="button" onClick={() => setShowForm(true)} className="text-sm font-medium text-pink-600 hover:text-pink-700">
          + Create Offer
        </button>
      )}

      {showForm && (
        <div className="grid grid-cols-1 items-end gap-3 rounded-xl border border-gray-200 bg-white p-4 sm:grid-cols-4">
          <Field label="Quantity">
            <NumberInput value={quantity} onChange={(e) => setQuantity(e.target.value)} />
          </Field>
          <div className="sm:col-span-2">
            <Field label="Offer Price / Percentage">
              <div className="flex gap-2">
                <NumberInput value={offerPrice} onChange={(e) => setOfferPrice(e.target.value)} />
                <button
                  type="button"
                  onClick={() => setOfferType(offerType === "dollar" ? "percent" : "dollar")}
                  className="w-14 shrink-0 rounded-lg border border-gray-300 bg-gray-50 text-sm font-semibold text-gray-600 hover:bg-gray-100"
                >
                  {offerType === "percent" ? "%" : "$"}
                </button>
              </div>
            </Field>
          </div>
          <SmallButton type="button" onClick={handleAdd}>Add</SmallButton>
        </div>
      )}

      <div className="overflow-hidden rounded-xl border border-gray-200">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-xs uppercase tracking-wide text-gray-500">
            <tr>
              <th className="px-3 py-2 text-left">Quantity</th>
              <th className="px-3 py-2 text-left">Price / Percentage</th>
              <th className="px-3 py-2 text-left">Offer Text</th>
              <th className="px-3 py-2 text-left">Active</th>
              <th className="px-3 py-2 text-right">Remove</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 bg-white">
            {offers.map((offer, index) => (
              <tr key={index}>
                <td className="px-3 py-2">{offer.quantity}</td>
                <td className="px-3 py-2">{offer.offerPrice}</td>
                <td className="px-3 py-2">
                  {offer.offerType === "percent"
                    ? `${offer.quantity} at ${offer.offerPrice}% OFF`
                    : `${offer.quantity} for $${offer.offerPrice}`}
                </td>
                <td className="px-3 py-2">
                  <Toggle id={`offerActive_${index}`} checked={offer.isActive} onChange={() => handleSetActive(index)} />
                </td>
                <td className="px-3 py-2 text-right">
                  <button type="button" onClick={() => handleDelete(index)} className="text-gray-500 hover:text-red-600">
                    <i className="fa fa-trash-o"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {offers.length === 0 && <p className="py-8 text-center text-sm text-gray-400">No offers found</p>}
      </div>
    </div>
  );
};